import { render, staticRenderFns } from "./logisaddimportV0.vue?vue&type=template&id=8a46a5fc"
import script from "./logisaddimportV0.vue?vue&type=script&lang=js"
export * from "./logisaddimportV0.vue?vue&type=script&lang=js"
import style0 from "./logisaddimportV0.vue?vue&type=style&index=0&id=8a46a5fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports